<template>
  <div id="performancePage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="عملکرد دانش آموز"></ActionBar>
    <div class="row container mx-auto no-gutters p-0 mt-2">
      <div class="col-12  rounded-b-lg header-rounded bg-white card-shadow pb-2">
        <div class="third-background header-rounded mb-3 white--text p-2">ثبت عملکرد دانش آموز</div>
        <div class="profile-field row mx-1">
          <div class="light-gray-bottom-border col-12">
            <div class="row">
              <div class="col-12 col-sm-8 col-lg-5 mx-auto d-flex">
                <i class="fas fa-calendar-check mt-2 pl-1"></i>
                <span class="pl-1 mt-1">انتخاب روز:</span>
                <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    min-width="auto"
                    offset-y
                    transition="scale-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="inputDate"
                        v-bind="attrs"
                        v-on="on"
                        append-icon="mdi-calendar"
                        class="input-border"
                        dense
                        hide-details
                        readonly
                        solo></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="date"
                      locale="fa-ir"
                      width="256"
                      @input="inputDatePicker"></v-date-picker>
                </v-menu>
              </div>
            </div>
          </div>
        </div>
        <div v-if="dataLoading" class="col-12 mt-10 col-md-6 col-lg-3 mx-auto text-center">
          در حال انجام
          <v-progress-linear
              color="forth"
              height="6"
              indeterminate
              rounded
          ></v-progress-linear>
        </div>
        <div v-else>
          <div v-if="isLoaded">
            <div v-for="(item) in mandatoryPerformance" :key="item.StudentPerformanceFieldID" class="row p-2">
              <div class="col-6 col-md-5">
                دسته بندی:
                <!--                :readonly="item.TypeOptional === 2"-->
                <v-autocomplete
                    v-model="categoriesVModels[item.StudentPerformanceFieldID]"
                    :items="categories[item.StudentPerformanceFieldID]"
                    class="input-border"
                    dense
                    hide-details
                    item-text="EvaluationCategoryName"
                    item-value="EvaluationCategoryID"
                    readonly
                    solo>
                </v-autocomplete>
              </div>
              <div class="col-6 col-md-5">
                عنوان:
                <v-autocomplete
                    v-model="subCategoriesVModels[item.StudentPerformanceFieldID]"
                    :items="subCategories[item.StudentPerformanceFieldID]"
                    class="input-border"
                    dense
                    hide-details
                    item-text="Name"
                    item-value="StudentPerformanceFieldID"
                    readonly
                    solo>
                </v-autocomplete>
              </div>
              <div v-if="item.TypeStudentPerformanceField === 1" class="fourth-border-bottom col-12 p-0">
                <div class="row p-2">
                  <div class="col-6 col-md-5">
                    <v-dialog
                        v-model="item.startTimeDialog"
                        width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="time[item.StudentPerformanceFieldID]"
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-clock-time-four-outline"
                            class="mr-1 input-border gray-bg-input "
                            dense
                            hide-details
                            label="از ساعت"
                            readonly
                            solo></v-text-field>
                      </template>
                      <v-time-picker
                          v-if="item.startTimeDialog"
                          v-model="time[item.StudentPerformanceFieldID]"
                          format="24hr"
                          full-width>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            text
                            @click="item.startTimeDialog = false">
                          تایید
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </div>
                  <div class="col-md-5 col-6">
                    <v-dialog
                        v-model="item.endTimeDialog"
                        width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="time2[item.StudentPerformanceFieldID]"
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-clock-time-four-outline"
                            class="mr-1 input-border gray-bg-input "
                            color="forth"
                            dense
                            hide-details
                            label="تا ساعت"
                            readonly
                            solo
                        ></v-text-field>
                      </template>
                      <v-time-picker
                          v-if="item.endTimeDialog"
                          v-model="time2[item.StudentPerformanceFieldID]"
                          color="forth"
                          format="24hr"
                          full-width>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="forth"
                            text
                            @click="item.endTimeDialog = false">
                          تایید
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </div>
                  <div class="col-md-2 col-sm-12 text-left">
                    <v-btn
                        v-if="showEditBtn"
                        color="primary"
                        outlined
                        rounded
                        @click="editPerformance(item.TypeStudentPerformanceField,item.StudentPerformanceValueID,item.StudentPerformanceFieldID,time[item.StudentPerformanceFieldID],time2[item.StudentPerformanceFieldID])">
                      ویرایش
                    </v-btn>
                  </div>
                </div>
              </div>
              <div v-if="item.TypeStudentPerformanceField === 2" class="fourth-border-bottom col-12 p-0">
                <div class="row p-2">
                  <div class="col-6 col-md-5">
                    <v-text-field
                        v-model="unitNumber[item.StudentPerformanceFieldID]"
                        class="input-border gray-bg-input"
                        dense
                        solo
                        type="number">
                    </v-text-field>
                  </div>
                  <div class="col-6 col-md-5 pt-4">
                    {{ item.NameUnitNumber }}
                  </div>
                  <div class="col-md-2 col-sm-12 text-left">
                    <v-btn
                        v-if="showEditBtn"
                        color="primary"
                        outlined
                        rounded
                        @click="editPerformance(item.TypeStudentPerformanceField,item.StudentPerformanceValueID,item.StudentPerformanceFieldID,unitNumber[item.StudentPerformanceFieldID])">
                      ویرایش
                    </v-btn>
                  </div>
                </div>
              </div>
              <div v-if="item.TypeStudentPerformanceField === 3" class="fourth-border-bottom col-12 p-0">
                <div class="row">
                  <v-radio-group v-model="selected[item.StudentPerformanceFieldID]" class="col-6 mx-auto p-0"
                                 hide-details
                                 row>
                    <v-radio
                        color="primary"
                        value="false">
                      <template slot="label">
                        <b class="pt-3">خیر</b>
                      </template>
                    </v-radio>
                    <v-radio
                        color="primary"
                        value="true">
                      <template slot="label">
                        <b class="pt-3">بله</b>
                      </template>
                    </v-radio>
                  </v-radio-group>
                  <div class="col-md-2 col-sm-12 text-left pl-5 pb-5">
                    <v-btn
                        v-if="showEditBtn"
                        color="primary"
                        outlined
                        rounded
                        @click="editPerformance(item.TypeStudentPerformanceField,item.StudentPerformanceValueID,item.StudentPerformanceFieldID,selected[item.StudentPerformanceFieldID])">
                      ویرایش
                    </v-btn>
                  </div>
                </div>
              </div>
              <div v-if="item.TypeStudentPerformanceField === 4" class="fourth-border-bottom col-12 p-0">
                <div class="row p-2">
                  <div class="col-6 col-md-5">
                    انتخاب گزینه
                  </div>
                  <div class="col-6 col-md-5">
                    <v-autocomplete
                        v-model="multipleValueSelected[item.StudentPerformanceFieldID]"
                        :items="multipleValues[item.StudentPerformanceFieldID]"
                        class="input-border"
                        dense
                        hide-details
                        item-text="name"
                        item-value="id"
                        solo>
                    </v-autocomplete>
                  </div>
                  <div class="col-md-2 col-sm-12 text-left">
                    <v-btn
                        v-if="showEditBtn"
                        color="primary"
                        outlined
                        rounded
                        @click="editPerformance(item.TypeStudentPerformanceField,item.StudentPerformanceValueID,item.StudentPerformanceFieldID,multipleValueSelected[item.StudentPerformanceFieldID])">
                      ویرایش
                    </v-btn>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div v-if="isLoaded">
            <div v-for="(item,index) in optionalPerformance" :key="index" class="row p-2">
              <div class="col-5">
                دسته بندی:
                <v-autocomplete
                    v-model="item.addCategoryID"
                    :items="items"
                    class="input-border"
                    dense
                    hide-details
                    item-text="name"
                    item-value="id"
                    solo
                    @change="getSubject(item.addCategoryID,index)">
                </v-autocomplete>
              </div>
              <div class="col-5">
                عنوان:
                <v-autocomplete
                    v-model="item.addSubCategoryId"
                    :items="item.subjects"
                    class="input-border"
                    dense
                    hide-details
                    item-text="Name"
                    item-value="StudentPerformanceFieldID"
                    solo
                    @change="showValues(index,item.addSubCategoryId)">
                </v-autocomplete>

              </div>
              <div class="col-2 align-self-end">
                <v-btn
                    class="pl-1 pb-1 rounded-lg"
                    color="primary"
                    icon
                    outlined
                    tile
                    @click="removePerformance(index,item.addSubCategoryId,item.subjects)">
                  <i class="fas fa-minus"></i>
                </v-btn>
              </div>
              <div v-if="item.typeSubject === 1" class="fourth-border-bottom col-12 p-0">
                <div class="row p-2">
                  <div class="col-6">
                    <v-dialog
                        v-model="item.startDateDialog"
                        width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="item.startDate"
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-clock-time-four-outline"
                            class="mr-1 input-border gray-bg-input "
                            dense
                            label="از ساعت"
                            readonly
                            solo
                        ></v-text-field>
                      </template>
                      <v-time-picker
                          v-if="item.startDateDialog"
                          v-model="item.startDate"
                          format="24hr"
                          full-width>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            text
                            @click="item.startDateDialog = false">
                          تایید
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </div>
                  <div class="col-6">
                    <v-dialog
                        v-model="item.endDateDialog"
                        width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="item.endDate"
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-clock-time-four-outline"
                            class="mr-1 input-border gray-bg-input "
                            color="forth"
                            dense
                            label="تا ساعت"
                            readonly
                            solo
                        ></v-text-field>
                      </template>
                      <v-time-picker
                          v-if="item.endDateDialog"
                          v-model="item.endDate"
                          color="forth"
                          format="24hr"
                          full-width>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="forth"
                            text
                            @click="item.endDateDialog = false">
                          تایید
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </div>
                </div>
              </div>
              <div v-if="item.typeSubject === 2" class="fourth-border-bottom col-12 p-0">
                <div class="row p-2">
                  <div class="col-6">
                    <v-text-field
                        v-model="item.unitNumber"
                        class="input-border gray-bg-input"
                        dense
                        solo
                        type="number">
                    </v-text-field>
                  </div>
                  <div class="col-6 pt-4">
                    {{ item.nameUnitNumber }}
                  </div>
                </div>
              </div>
              <div v-if="item.typeSubject=== 3" class="fourth-border-bottom col-12 p-0">
                <div class="row p-2">
                  <div class="col-6">
                    <v-checkbox
                        v-model="item.selectedBoolean"
                        label="خیر"
                        value="false"></v-checkbox>
                  </div>
                  <div class="col-6">
                    <v-checkbox
                        v-model="item.selectedBoolean"
                        label="بله"
                        value="true"></v-checkbox>
                  </div>
                </div>
              </div>
              <div v-if="item.typeSubject === 4" class="fourth-border-bottom col-12 p-0">
                <div class="row p-2">
                  <div class="col-6">
                    انتخاب گزینه
                  </div>
                  <div class="col-6">
                    <v-autocomplete
                        v-model="item.multipleSelectedValue"
                        :items="item.multipleSelectItems"
                        class="input-border"
                        dense
                        hide-details
                        item-text="name"
                        item-value="id"
                        solo>
                    </v-autocomplete>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-fab-transition v-if="showAddBtn">
      <v-btn
          id="memberShipFabBtn"
          color="forth"
          dark
          fab
          fixed
          large
          left
          @click="addPerformance">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-fab-transition>
    <div v-if="showRegisterBtn" class="col-6 text-center mx-auto">
      <v-btn :disabled="checkFields()" block color="primary" rounded @click="registerData">
        ثبت
      </v-btn>
    </div>
    <FooterMenu/>
    <!--    <v-dialog
            v-model="showEditDialog"
            persistent
            width="500">
          <v-card class="text-center pt-5">
            <v-card-text v-if="isEditLoaded" class="pb-0">
              <div v-if="editType === 1" class="fourth-border-bottom col-12 p-0">
                <div class="row p-2">
                  <div class="col-6">
                    <v-dialog
                        v-model="editStartTimeDialog"
                        width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="editStartTime"
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-clock-time-four-outline"
                            class="mr-1 input-border gray-bg-input "
                            dense
                            label="از ساعت"
                            readonly
                            solo
                        ></v-text-field>
                      </template>
                      <v-time-picker
                          v-if="editStartTimeDialog"
                          v-model="editStartTime"
                          format="24hr"
                          full-width>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            text
                            @click="editStartTimeDialog = false">
                          تایید
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </div>
                  <div class="col-6">
                    <v-dialog
                        v-model="editEndTimeDialog"
                        width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="editEndTime"
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-clock-time-four-outline"
                            class="mr-1 input-border gray-bg-input "
                            color="forth"
                            dense
                            label="تا ساعت"
                            readonly
                            solo
                        ></v-text-field>
                      </template>
                      <v-time-picker
                          v-if="editEndTimeDialog"
                          v-model="editEndTime"
                          color="forth"
                          format="24hr"
                          full-width>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="forth"
                            text
                            @click="editEndTimeDialog = false">
                          تایید
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </div>
                </div>
              </div>
              <div v-if="editType === 2" class="fourth-border-bottom col-12 p-0">
                <div class="row p-2">
                  <div class="col-6">
                    <v-text-field
                        v-model="editUnitNumber"
                        class="input-border gray-bg-input"
                        dense
                        solo
                        type="number">
                    </v-text-field>
                  </div>
                </div>
              </div>
              <div v-if="editType=== 3" class="fourth-border-bottom col-12 p-0">
                <div class="row p-2">
                  <div class="col-6">
                    <v-checkbox
                        v-model="editSelectedBoolean"
                        label="خیر"
                        value="false"></v-checkbox>
                  </div>
                  <div class="col-6">
                    <v-checkbox
                        v-model="editSelectedBoolean"
                        label="بله"
                        value="true"></v-checkbox>
                  </div>
                </div>
              </div>
              <div v-if="editType === 4" class="fourth-border-bottom col-12 p-0">
                <div class="row p-2">
                  <div class="col-6">
                    انتخاب گزینه
                  </div>
                  <div class="col-6">
                    <v-autocomplete
                        v-model="editMultipleValue"
                        :items="editMultipleItems"
                        class="input-border"
                        dense
                        hide-details
                        item-text="name"
                        item-value="id"
                        solo>
                    </v-autocomplete>
                  </div>
                </div>
              </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pt-1 pb-3">
              <v-btn block class="primary" rounded @click="edit">
                ویرایش
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>-->
    <v-dialog
        v-model="showResultDialog"
        persistent
        hide-overlay
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ dialogResult }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3">
          <v-btn block class="primary" rounded @click="showResultDialog = !showResultDialog">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _this = null;
import moment from "moment-jalaali";
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";

export default {
  name: "Performance",
  metaInfo: {
    title: 'مسیربرتر-عملکرد دانش آموز'
  },
  components: {FooterMenu, ActionBar},
  data: () => ({
    showRegisterBtn: null,
    isEditLoaded: false,
    showLoaderDialog: false,
    dataLoading: false,
    editMultipleValue: null,
    editMultipleItems: [],
    editEndTime: null,
    editUnitNumber: null,
    editStartTime: null,
    editSelectedBoolean: null,
    editStartTimeDialog: false,
    editEndTimeDialog: false,
    showEditDialog: null,
    inputDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    selected: [],
    menu: false,
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    items: [],
    categoryID: [],
    studentPerformance: null,
    subjects: [],
    subjectID: [],
    typeSubject: null,
    time: {},
    modal: false,
    time2: {},
    modal2: false,
    nameUnitNumber: null,
    multipleSelectItems: [],
    multipleSelectedId: null,
    mandatoryPerformance: [],
    categories: [],
    categoriesVModels: {},
    subCategories: [],
    subCategoriesVModels: {},
    timeDialogStartDate: [],
    unitNumber: {},
    multipleValueSelected: {},
    optionalPerformance: [],
    showResultDialog: false,
    isLoaded: false,
    dialogResult: null,
    showAddBtn: false,
    allPerformances: null,
    multipleValues: [],
    editType: null,
    registeredBefore: false,
    showEditBtn: false

  }),
  mounted() {
    _this = this;
    this.inputDate = this.$convertDate(this.inputDate)
    this.getData()


  },
  methods: {
    getSubject(id, index) {
      this.optionalPerformance[index].typeSubject = null
      this.typeSubject = null;
      let list = _this.studentPerformance
      this.optionalPerformance[index].subjects = list.filter(x => x.EvaluationCategoryID === id)
    },
    showValues(index, id) {
      let allSubjects = _this.studentPerformance
      var test = allSubjects.findIndex(p => p.StudentPerformanceFieldID === id)
      allSubjects.splice(test, 1)
      _this.studentPerformance = allSubjects
      let subjects = this.optionalPerformance[index].subjects;
      let item = subjects.filter(x => x.StudentPerformanceFieldID === id)
      this.optionalPerformance[index].typeSubject = item[0].TypeStudentPerformanceField
      if (item[0].TypeStudentPerformanceField === 2) {
        this.optionalPerformance[index].nameUnitNumber = item[0].NameUnitNumber
      } else if (item[0].TypeStudentPerformanceField === 4) {
        let items = item[0].NameMuplitles;
        for (const i in items) {
          this.optionalPerformance[index].multipleSelectItems.push({id: items[i], name: i})
        }
      }
    },
    getData() {
      this.dataLoading = true
     let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };
      fetch(this.$baseUrl + "StudentPerformanceValueManagement/ListFields", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)

            for (let i = 0; i < json.length; i++) {
              if (json[i].TypeStudentPerformanceField === 4) {
                let items = json[i].NameMuplitles;
                let multipleValue = []
                for (const i in items) {
                  multipleValue.push({id: items[i], name: i})
                }
                json[i]['multipleValue'] = multipleValue
              } else if (json[i].TypeStudentPerformanceField === 1) {
                json[i]['startTimeDialog'] = false
                json[i]['endTimeDialog'] = false
                json[i]['refStartDialog'] = 'a' + i
              }
            }

            let arr = []
            let optional = json.filter(x => x.TypeOptional === 1)
            _this.studentPerformance = optional
            if (optional.length > 0) {
              _this.showAddBtn = true
            }
            _this.optionalPerformances = optional
            let EvaluationCategory = [...new Set(optional.map(obj => obj.EvaluationCategoryID))];
            for (let i = 0; i < EvaluationCategory.length; i++) {
              arr.push({
                name: optional.filter(x => x.EvaluationCategoryID === EvaluationCategory[i])[0].EvaluationCategoryName,
                id: EvaluationCategory[i]
              })
            }
            _this.mandatoryPerformance = json.filter(x => x.TypeOptional === 2)
            // let mandatory = json.filter(x => x.TypeOptional === 2)

            _this.items = arr

            for (let i in json) {
              _this.categories[json[i].StudentPerformanceFieldID] = json
              _this.categoriesVModels[json[i].StudentPerformanceFieldID] = (json[i].EvaluationCategoryID)
              _this.subCategoriesVModels[json[i].StudentPerformanceFieldID] = (json[i].StudentPerformanceFieldID)
              let multiple = json[i].NameMuplitles
              let values = []
              for (const j in multiple) {
                values.push({id: multiple[j], name: j})
              }
              _this.multipleValues[json[i].StudentPerformanceFieldID] = values
            }
            let catIdVModel = _this.categoriesVModels
            for (let i in catIdVModel) {
              _this.subCategories[i] = json
            }

            _this.allPerformances = json
            _this.isLoaded = true
            _this.dataLoading = false
            _this.showRegisterBtn = true
            if(!this.registeredBefore) {
              this.getHistory()
            }

          })
          .catch(error => console.log('error', error));

    },
    inputDatePicker() {
      this.dataLoading = true
      this.menu = false
      this.inputDate = moment(this.date).format('jYYYY/jMM/jDD')
      this.getHistory()
    },
    addPerformance() {
      this.showRegisterBtn = true
      if (this.optionalPerformance.length === 0) {
        this.optionalPerformance.push({
          addCategoryID: '',
          addSubCategoryId: '',
          typeSubject: '',
          nameUnitNumber: '',
          multipleSelectItems: '',
          startDateDialog: false,
          endDateDialog: false,
          startDate: '',
          endDate: '',
          unitNumber: '',
          multipleSelectedValue: '',
          selectedBoolean: '',
          subjects: []
        })
      } else if (this.optionalPerformance.length !== 0 && this.optionalPerformance[this.optionalPerformance.length - 1].subjects.length !== 0) {
        this.optionalPerformance.push({
          addCategoryID: '',
          addSubCategoryId: '',
          typeSubject: '',
          nameUnitNumber: '',
          multipleSelectItems: '',
          startDateDialog: false,
          endDateDialog: false,
          startDate: '',
          endDate: '',
          multipleSelectedValue: '',
          selectedBoolean: '',
          unitNumber: '',
          subjects: []
        })
      } else {
        this.showResultDialog = true;
        this.dialogResult = 'لطفا مقادیر عملکرد های اضافه شده را تکمیل کنید.'
      }
      if (_this.optionalPerformances.length === this.optionalPerformance.length) {
        this.showAddBtn = false
      }

    },
    removePerformance(index, id, items) {
      _this.studentPerformance.push(items.filter(x => x.StudentPerformanceFieldID === id)[0])
      this.optionalPerformance.splice(index, 1)
    },
    registerData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      let fieldID = this.subCategoriesVModels;
      let startTime = this.time;
      let endTime = this.time2;
      let appUserId = this.$getUserData().userID;
      let studentId = this.$getUserData().studentID;
      let booleanData = this.selected;
      let multipleData = this.multipleValueSelected;
      let valueNumber = this.unitNumber
      let mandatory = this.allPerformances


      let optional = this.optionalPerformance
      if (optional.length > 0) {
        for (let i = 0; i < optional.length; i++) {
          fieldID[optional[i].addSubCategoryId] = optional[i].addSubCategoryId;
          switch (optional[i].typeSubject) {
            case 1:
              startTime[optional[i].addSubCategoryId] = optional[i].startDate;
              endTime[optional[i].addSubCategoryId] = optional[i].endDate;
              break
            case 2:
              valueNumber[optional[i].addSubCategoryId] = optional[i].unitNumber;
              break
            case 3:
              booleanData[optional[i].addSubCategoryId] = optional[i].selectedBoolean;
              break
            case 4:
              multipleData[optional[i].addSubCategoryId] = optional[i].multipleSelectedValue;
              break
          }
        }
      }
      let j = -1
      for (let i = 0; i < mandatory.length; i++) {
        switch (mandatory[i].TypeStudentPerformanceField) {
          case 1:
            if (startTime[mandatory[i].StudentPerformanceFieldID] !== undefined) {
              j++
              urlencoded.append("items[" + j + "].StartTime", startTime[mandatory[i].StudentPerformanceFieldID]);
              urlencoded.append("items[" + j + "].EndTime", endTime[mandatory[i].StudentPerformanceFieldID]);
              urlencoded.append("items[" + j + "].ModifiedDate", new Date(this.date).toISOString().slice(0, 10));
              urlencoded.append("items[" + j + "].AppUserID", appUserId);
              urlencoded.append("items[" + j + "].StudentProfileID", studentId);
              urlencoded.append("items[" + j + "].StudentPerformanceFieldID", fieldID[mandatory[i].StudentPerformanceFieldID]);
            }
            break
          case 2:
            if (valueNumber[mandatory[i].StudentPerformanceFieldID] !== undefined) {
              j++
              urlencoded.append("items[" + j + "].ValueNumber", valueNumber[mandatory[i].StudentPerformanceFieldID]);
              urlencoded.append("items[" + j + "].ModifiedDate", new Date(this.date).toISOString().slice(0, 10));
              urlencoded.append("items[" + j + "].AppUserID", appUserId);
              urlencoded.append("items[" + j + "].StudentProfileID", studentId);
              urlencoded.append("items[" + j + "].StudentPerformanceFieldID", fieldID[mandatory[i].StudentPerformanceFieldID]);
            }
            break
          case 3:
            if (booleanData[mandatory[i].StudentPerformanceFieldID] !== undefined) {
              j++
              urlencoded.append("items[" + j + "].ValueBoolian", booleanData[mandatory[i].StudentPerformanceFieldID]);
              urlencoded.append("items[" + j + "].ModifiedDate", new Date(this.date).toISOString().slice(0, 10));
              urlencoded.append("items[" + j + "].AppUserID", appUserId);
              urlencoded.append("items[" + j + "].StudentProfileID", studentId);
              urlencoded.append("items[" + j + "].StudentPerformanceFieldID", fieldID[mandatory[i].StudentPerformanceFieldID]);
            }
            break
          case 4:
            if (multipleData[mandatory[i].StudentPerformanceFieldID] !== undefined) {
              j++
              urlencoded.append("items[" + j + "].ValueMuplitle", multipleData[mandatory[i].StudentPerformanceFieldID]);
              urlencoded.append("items[" + j + "].ModifiedDate", new Date(this.date).toISOString().slice(0, 10));
              urlencoded.append("items[" + j + "].AppUserID", appUserId);
              urlencoded.append("items[" + j + "].StudentProfileID", studentId);
              urlencoded.append("items[" + j + "].StudentPerformanceFieldID", fieldID[mandatory[i].StudentPerformanceFieldID]);
            }
            break
        }
      }

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "StudentPerformanceValueManagement/Define", requestOptions)
          .then(response => response.text())
          .then(result => {

            _this.dialogResult = result
            _this.showLoaderDialog = false;
            _this.showResultDialog = true;
            this.registeredBefore=false
            this.getData()


          })
          .catch(error => console.log('error', error));
    },
    checkFields() {
      let isValid = false
      let mandatory = this.mandatoryPerformance
      for (let i = 0; i < mandatory.length; i++) {
        if (mandatory[i].TypeStudentPerformanceField === 1) {
          if (this.time[mandatory[i].StudentPerformanceFieldID] === undefined || this.time2[mandatory[i].StudentPerformanceFieldID] === undefined) {
            return true
          }
        } else if (mandatory[i].TypeStudentPerformanceField === 2) {
          if (this.unitNumber[mandatory[i].StudentPerformanceFieldID] === undefined) {
            return true
          }
        } else if (mandatory[i].TypeStudentPerformanceField === 3) {
          if (this.selected[mandatory[i].StudentPerformanceFieldID] === undefined) {
            return true
          }
        } else if (mandatory[i].TypeStudentPerformanceField === 4) {
          if (this.multipleValueSelected[mandatory[i].StudentPerformanceFieldID] === undefined) {
            return true
          }
        }
      }
      return isValid
    },
    getHistory() {
      _this.mandatoryPerformance = []
      _this.optionalPerformance = []
      _this.time = {};
      _this.time2 = {};
      _this.subCategoriesVModels = {};
      _this.unitNumber = {};
      _this.selected = {};
      _this.multipleValueSelected = {};
      _this.isLoaded = false
     let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "StudentPerformanceValueManagement/ListHistory?StartDate=" + new Date(this.date).toISOString().slice(0, 10) + "T00:00:00&EndDate=" + new Date(this.date).toISOString().slice(0, 10) + "T23:00:00&IsInSchool=false", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            if (json.length > 0) {
              let all = _this.allPerformances
              for (let i = 0; i < all.length; i++) {
                for (let j = 0; j < json.length; j++) {
                  if (all[i].StudentPerformanceFieldID === json[j].StudentPerformanceFieldID) {
                    json[j].TypeOptional = all[i].TypeOptional
                    json[j].NameUnitNumber= all[i].NameUnitNumber
                  }
                }
              }
              if (json.length > 0) {
                this.registeredBefore = false
                _this.showEditBtn = true;
                _this.showRegisterBtn = false;
                for (let i = 0; i < json.length; i++) {
                  if (json[i].StartTime !== null) {
                    _this.time[json[i].StudentPerformanceFieldID] = json[i].StartTime
                    _this.time2[json[i].StudentPerformanceFieldID] = json[i].EndTime
                    _this.subCategoriesVModels[json[i].StudentPerformanceFieldID] = json[i].StudentPerformanceFieldID
                    _this.mandatoryPerformance.push({
                      StudentPerformanceFieldID: json[i].StudentPerformanceFieldID,
                      TypeStudentPerformanceField: 1,
                      startTimeDialog: false,
                      endTimeDialog: false,
                      TypeOptional: json[i].TypeOptional,
                      StudentPerformanceValueID: json[i].StudentPerformanceValueID
                    })
                  } else if (json[i].ValueNumber !== null) {
                    _this.unitNumber[json[i].StudentPerformanceFieldID] = json[i].ValueNumber
                    _this.subCategoriesVModels[json[i].StudentPerformanceFieldID] = json[i].StudentPerformanceFieldID
                    _this.mandatoryPerformance.push({
                      StudentPerformanceFieldID: json[i].StudentPerformanceFieldID,
                      TypeStudentPerformanceField: 2,
                      NameUnitNumber: json[i].NameUnitNumber,
                      TypeOptional: json[i].TypeOptional,
                      StudentPerformanceValueID: json[i].StudentPerformanceValueID,

                    })
                  } else if (json[i].ValueBoolian !== null) {
                    _this.selected[json[i].StudentPerformanceFieldID] = (json[i].ValueBoolian).toString()
                    _this.subCategoriesVModels[json[i].StudentPerformanceFieldID] = json[i].StudentPerformanceFieldID
                    _this.mandatoryPerformance.push({
                      StudentPerformanceFieldID: json[i].StudentPerformanceFieldID,
                      TypeStudentPerformanceField: 3,
                      TypeOptional: json[i].TypeOptional,
                      StudentPerformanceValueID: json[i].StudentPerformanceValueID
                    })
                  } else if (json[i].ValueMuplitle) {
                    _this.multipleValueSelected[json[i].StudentPerformanceFieldID] = json[i].ValueMuplitle
                    _this.subCategoriesVModels[json[i].StudentPerformanceFieldID] = json[i].StudentPerformanceFieldID
                    _this.mandatoryPerformance.push({
                      StudentPerformanceFieldID: json[i].StudentPerformanceFieldID,
                      TypeStudentPerformanceField: 4,
                      TypeOptional: json[i].TypeOptional,
                      StudentPerformanceValueID: json[i].StudentPerformanceValueID
                    })
                  }
                }
              }
            } else {
              _this.getData()
              _this.showEditBtn = false
              this.registeredBefore = true
              _this.showRegisterBtn = true
            }
            _this.isLoaded = true
            _this.dataLoading = false

          })
          .catch(error => console.log('error', error));
    },
    editPerformance(type, valueId, fieldId, value1, value2) {
      this.showLoaderDialog = true
     let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
      let urlencoded = new URLSearchParams();
      urlencoded.append("StudentPerformanceValueID", valueId);
      switch (type) {
        case 1:
          urlencoded.append("StartTime", value1);
          urlencoded.append("EndTime", value2);
          break
        case 2:
          urlencoded.append("ValueNumber", value1);
          break
        case 3:
          urlencoded.append("ValueBoolian", value1);
          break
        case 4:
          urlencoded.append("ValueMuplitle", value1);
          break

      }

      urlencoded.append("ModifiedDate", new Date(this.date).toISOString().slice(0, 10));
      urlencoded.append("AppUserID", _this.$getUserData().userID);
      urlencoded.append("StudentProfileID", _this.$getUserData().studentID);
      urlencoded.append("StudentPerformanceFieldID", fieldId);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "StudentPerformanceValueManagement/Edit", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.dialogResult = result
            _this.showLoaderDialog = false
            _this.showResultDialog = true;
          })
          .catch(error => console.log('error', error));
    },
    edit() {
      this.showEditDialog = false
    },
    /*  editPerformance(id, type) {
       this.showEditDialog = true;
       this.isEditLoaded = false;
       this.editType = type
      let myHeaders = new Headers();
       myHeaders.append("Authorization", _this.$getUserData().token);


       let requestOptions = {
         method: 'GET',
         headers: myHeaders,
         redirect: 'follow'
       };

       fetch(this.$baseUrl + "StudentPerformanceValueManagement/Edit?StudentPerformanceValueID=" + id, requestOptions)
           .then(response => response.text())
           .then(result => {
             let json = JSON.parse(result)
             if (json.StartTime !== null) {
               _this.editStartTime = json.StartTime;
               _this.editEndTime = json.EndTime;
             } else if (json.ValueNumber !== null) {
               _this.editUnitNumber = json.ValueNumber
             } else if (json.ValueBoolian !== null) {
               _this.editSelectedBoolean = json.ValueBoolian
             } else if (json.ValueMuplitle !== null) {
               _this.editMultipleValue = json.ValueMuplitle
             }
             _this.isEditLoaded = true
           })
           .catch(error => console.log('error', error));
     },*/
  }
}
</script>


